export const SET_CMS_PAGES = 'SET_CMS_PAGES';